import findAllFor from '../filters/find-all-for';

const canBeSelected = (element) => {
  const constraints = findAllFor(element);

  return constraints.some((constraint) => constraint.selectable);
};

export default canBeSelected;
